import { browser } from '$app/environment';
import { Page } from '$lib/utils/page';
import { pageConditions } from './__config/conditions';
import { policy, policyExceptionHandler } from './-policy';

export const prerender = true;

export async function load() {
    if (browser) {
        const page = new Page({ 
            routePath: '/prospect-register',
            requireAuth: false,
            policies: { policy, policyExceptionHandler }, 
            conditions: pageConditions
        });
        return {
            page
        };
    }
}
